module.exports = __webpack_public_path__ + "media/src/images/icons/play/primary-e8667aec4ee90ba1e10342e1a8d641f3.svg";